import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { PROMO_TEXT } from "@/components/aziende/plans";

const Dot = () => (
  <span className="relative flex h-2.5 w-2.5 shrink-0">
    <span className="promo-ping absolute inline-flex h-full w-full rounded-full bg-[#00e5ff]" />
    <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-[#00e5ff] shadow-[0_0_10px_#00e5ff]" />
  </span>
);

export const PromoBanner = () => (
  <div className="promo-banner glass mb-10 flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-4 rounded-2xl border px-5 py-4 sm:px-7 sm:py-5" data-testid="promo-banner">
    <span className="flex items-center gap-3 text-[11px] font-semibold tracking-[0.2em] uppercase text-cyan whitespace-nowrap">
      <Dot /> Promozione Primi Partner
    </span>
    <p className="text-sm sm:text-base text-white/90 leading-relaxed">{PROMO_TEXT}</p>
  </div>
);

export const PromoPill = () => (
  <Link to="/aziende/piani" className="promo-banner glass group mt-6 inline-flex min-h-[44px] items-center gap-3 rounded-full border px-4 py-2 text-xs sm:text-sm text-white/90" data-testid="aziende-promo-pill">
    <Dot />
    <span>
      <span className="font-semibold text-cyan">Promozione Primi Partner:</span> le prime 6 aziende entrano gratis
    </span>
    <ArrowRight className="h-4 w-4 shrink-0 text-cyan transition-transform duration-300 group-hover:translate-x-0.5" />
  </Link>
);
